// import AppConstant from '../../../config/app.constants';
import BaseController from '../common/location_zone.base.controller';

class LocationZoneAllController extends BaseController {
    /*@ngInject*/
    constructor(Auth, $state, User, LocationZoneService, Modal, $translate, $location, $stateParams) {

        super(Auth, $state, User, LocationZoneService, Modal, $translate)

        this.id = 'location_zone.all'
        this.Auth = Auth;
        this.User = User;
        this.$state = $state;
        this.$translate = $translate;
        this.Modal = Modal;
        this.$location = $location;
        this.$stateParams = $stateParams;
        this.page = 1;

        this.model = {
            currentBranch: this.User.getUser().branchId,
            searchText: '',
            locationZoneObj: {
                results: [],
                totalRecords: 0,
                loading: false,
                pagination: {
                    page: 1,
                    total: 0,
                    pageLimit: 10,
                    maxPages: 10
                }
            }
        }
    }

    $onInit() {
        let pageId = this.$stateParams.page
        if (pageId > 0) {
            this.page = pageId;
        }
        this.loadData();
    }

    edit(zone) {
        this.$state.go('location_zone.edit', ({
            id: zone.id
        }))
    }

    generateSearchObj() {
        const obj = {
            queryJSON: {
                rules: [{
                    field: 'id',
                    condition: 'like',
                    data: '%' + this.model.searchText + '%'
                },
                {
                    field: 'name',
                    condition: 'like',
                    data: '%' + this.model.searchText + '%'
                },
                {
                    field: 'type',
                    condition: 'like',
                    data: '%' + this.model.searchText + '%'
                }],
                operator: 'OR'
            }
        }
        return obj.queryJSON.rules.length ? obj : null;
    }

    loadData() {
        const searchObj = this.generateSearchObj();

        this.model.locationZoneObj.loading = true;
        this.Service.all(searchObj, (this.model.locationZoneObj.pagination.page - 1) * this.model.locationZoneObj.pagination.pageLimit, this.model.locationZoneObj.pagination.pageLimit)
            .then((data) => {
                this.model.locationZoneObj.totalRecords = data.total;
                this.model.locationZoneObj.results = data.results;
            })
            .catch((err) => {
                if (err && err.data && err.data.message) {
                    this.Modal.errorModal(err.data.message);
                }
            })
            .finally(() => {
                this.model.locationZoneObj.loading = false;
            })
    }

    search() {
        this.page = 1;
        this.model.locationZoneObj.pagination.page = 1;
        let newUrl = (window.location.pathname).replace('/' + this.$stateParams.page, '/' + this.page)
        this.$stateParams.page = this.page;
        this.$location.path(newUrl)
        this.loadData();
    }

    refresh() {
        this.loadData();
    }

    pageChange() {
        let newUrl = (window.location.pathname).replace('/' + this.$stateParams.page, '/' + this.page)
        this.$stateParams.page = this.page;
        this.$location.path(newUrl)
        this.loadData()
    }

    delete(zone) {
        if (this.allowOnlyOnce) return;
        this.allowOnlyOnce = true;
        this.Modal.confirm({
            header: this.$translate.instant('common.confirm_delete_title'),
            message: this.$translate.instant('common.confirm_delete_message') + ` <strong>${zone.id}</strong>?`,
            callback: (({
                modal,
                $scope
            }) => {
                $scope.loading = true;
                this.Service.remove(zone.id, zone.name, zone.description, this.model.currentBranch)
                    .then(() => {
                        modal.close();
                        this.refresh();
                    })
                    .catch(() => { })
                    .finally(() => {
                        this.allowOnlyOnce = false;
                        $scope.loading = false;
                    })
            }),
            negative: (({
                modal,
            }) => {
                this.allowOnlyOnce = false;
                modal.close();
            }),
            type: 'danger'
        })
    }

};

export default LocationZoneAllController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/location_zone/all/location_zone.all.controller.js